import { ReactElement } from 'react';

import styles from './PlanEngagement.module.scss';

interface IReadOnlyArchivedRowProps {
  title: string;
  subtitle: string;
}

const ReadOnlyArchivedRow = ({ title, subtitle }: IReadOnlyArchivedRowProps): ReactElement => (
  <div className={styles.archivedRow}>
    <span className={styles.archivedTitle}>{title}</span>
    <span className={styles.entryReported}>{subtitle}</span>
  </div>
);

export default ReadOnlyArchivedRow;
